function encodeQueryParams(paramConfigMap, query) {
  var encodedQuery = {};
  var paramNames = Object.keys(query);

  for (var _i = 0, _paramNames = paramNames; _i < _paramNames.length; _i++) {
    var paramName = _paramNames[_i];
    var decodedValue = query[paramName];

    if (!paramConfigMap[paramName]) {
      encodedQuery[paramName] = decodedValue == null ? decodedValue : String(decodedValue);
    } else {
      encodedQuery[paramName] = paramConfigMap[paramName].encode(query[paramName]);
    }
  }

  return encodedQuery;
}

var encodeQueryParams_default = encodeQueryParams;
export { encodeQueryParams_default as default, encodeQueryParams };